import React from 'react'
import "../styles/footer.css"

const Footer = () => {
  return (
    <>
   <footer id="footer" className="mt-5 footer dark-background">

  <div className="container footer-top">
    <div className="row gy-4">

      {/* About / Brand */}
      <div className="col-lg-4 col-md-6 footer-about">
        <a href="/" className="logo d-flex align-items-center">
          <span className="sitename">Tuwe Initiative</span>
        </a>

      <p className="mt-3 footer-ip">
        Tuwe Initiative&trade; is the originator and owner of the Last-Mile Education Delivery Model (L-MEDM&trade;).
        This model and its associated frameworks are protected intellectual property and may not be
        replicated or implemented without prior written permission.
      </p>

        <div className="social-links d-flex mt-4">
           <a href="#" aria-label="Facebook"><i className="bi bi-facebook"></i></a>
          <a href="#" aria-label="Instagram"><i className="bi bi-instagram"></i></a>
          <a href="#" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
        </div>
      </div>

      {/* Address */}
      <div className="col-lg-3 col-md-6 footer-contact">
        <h4>Our Address</h4>
        <p>
       
          Nairobi, Kenya
        </p>
      </div>

      {/* Contact */}
      <div className="col-lg-3 col-md-6 footer-contact">
        <h4>Contact Us</h4>
     
        <p>
          <strong>Email:</strong><br />
          Wanjiru.Nganga@tuweinitiative.org
        </p>
      </div>

      {/* Quick Links */}
      <div className="col-lg-2 col-md-6 footer-links">
        <h4>Quick Links</h4>
        <ul>
          <li><i className="bi bi-chevron-right"></i> <a href="#hero">Home</a></li>
          <li><i className="bi bi-chevron-right"></i> <a href="#about-us">About Us</a></li>
          <li><i className="bi bi-chevron-right"></i> <a href="#services">Programs</a></li>
          <li><i className="bi bi-chevron-right"></i> <a href="#contact">Contact</a></li>
        </ul>
      </div>

    </div>
  </div>

  {/* Copyright */}
  <div className="container copyright text-center">
    <p>
      © <span id="year"></span> <strong>Tuwe Initiative</strong>. All Rights Reserved
    </p>
  </div>

</footer>
 
    </>
  )
}

export default Footer